<template>
  <div
    class="bet-slip-content-wrapper"
    :class="{
      'd-block': currentState !== 'BET_PREPARE',
      'has-tabs': betTabs.length > 0 && betSlipBetCount > 0,
    }"
  >
    <div v-if="$isElectron && terminalInfo && terminalInfo.can_clerk_login !== '1' && !isScanningCodeForMobile" class="simple-keyboard-wrapper">
      <simple-keyboard :input="vk_input_value" />
    </div>

    <ul class="tab-nav p-0 m-0 bet-slip-open-bets-tab d-flex">
      <li
        class="tab-nav-item"
        style="text-overflow: unset !important"
        :class="{ active: sideMode === 'BET_SLIP_TAB' }"
        @click="
          sideMode = 'BET_SLIP_TAB';
          openBetSlip();
        "
      >
        <span style="font-size: 0.875rem">{{ $t('BetSlip.Bet Slip') }}</span
        >&nbsp;
        <span class="item-count" v-if="getBetSlipBetsCount() > 0">{{ getBetSlipBetsCount() }}</span>
      </li>
      <li
        class="tab-nav-item"
        :class="{ active: sideMode === 'OPEN_BETS_TAB' }"
        v-if="isLogged && isPlayer"
        style="text-overflow: unset !important"
        @click="
          sideMode = 'OPEN_BETS_TAB';
          openBetSlip();
        "
      >
        <span style="font-size: 0.875rem">{{ $t('BetSlip.Open Bets') }}</span
        >&nbsp;
        <span class="item-count" v-if="getOpenBetsCount()">{{ getOpenBetsCount() }}</span>
      </li>
      <li class="tab-nav-item close-bet-slip" @click="closeBetSlip" style="width: 50px; flex-shrink: 0">
        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.76028 8.92949L17.5509 1.11722C17.806 0.861263 17.8056 0.446859 17.5496 0.191327C17.2937 -0.0640057 16.879 -0.0633459 16.6237 0.192647L9.29675 7.53991L1.96982 0.192382C1.71448 -0.0635776 1.30011 -0.0642374 1.04412 0.191063C0.915792 0.319158 0.851627 0.486972 0.851627 0.654786C0.851627 0.822171 0.915363 0.989325 1.0428 1.11719L8.83326 8.92949C8.95591 9.05277 9.12284 9.12195 9.29675 9.12195C9.47067 9.12195 9.6374 9.05257 9.76028 8.92949Z"
            fill="white"
          />
        </svg>
      </li>
    </ul>

    <template v-if="sideMode === 'BET_SLIP_TAB'">
      <template v-if="betTabs.length > 0 && betSlipBetCount > 0 && currentState === 'BET_PREPARE'">
        <bet-slip-tab-options
          :selectedType="selectedType"
          :betTabs="betTabs"
          @straightChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'straight',
              name: 'BetSlip.Straight',
            })
          "
          @parlayChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'parlay',
              name: 'BetSlip.Parlay',
            })
          "
          @rrChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'round_robin',
              name: 'BetSlip.RR',
            })
          "
          @teaserChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'teaser',
              name: 'BetSlip.Teaser',
            })
          "
          @ifWinChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'if_win',
              name: 'BetSlip.If Bet',
            })
          "
          @reverseChoose="
            setSelectedBetTypeAndGetOptions({
              type: 'reverse',
              name: 'BetSlip.Reverse',
            })
          "
        ></bet-slip-tab-options>
      </template>

      <template v-if="currentState === 'BET_PREPARE'">
        <form @submit.prevent style="height: 100%">
          <bet-slip-tab v-if="sideMode === 'BET_SLIP_TAB'"></bet-slip-tab>
        </form>
      </template>

      <template v-if="currentState === 'BET_CONFIRMATION'">
        <bet-slip-bet-confirmation-modal />
      </template>

      <template v-if="currentState === 'BET_PLACED' && isLineChanged === false">
        <bet-slip-bet-place-modal />
      </template>

      <template v-if="currentState === 'BET_PLACED' && isLineChanged === true">
        <bet-slip-bet-place-modal-line-changed />
      </template>
    </template>

    <open-bets-tab
      v-if="sideMode === 'OPEN_BETS_TAB' && loginType === LoginTypes.Player"
      :status="openBetsStatus"
      :data="openBetsSummary"
      :showMoreButton="true"
    ></open-bets-tab>
    <open-bets-tab
      v-if="sideMode === 'OPEN_BETS_TAB' && loginType === ExternalWagerLoginTypes.DepositTicket"
      :status="ticketOpenBetsStatus"
      :data="ticketOpenBets"
      :showMoreButton="false"
    ></open-bets-tab>

    <modal v-if="hasConfirmationErrors" @close="hasConfirmationErrors = false" :closeable="true" :closeIconNew="true">
      <p slot="body" class="text-center" v-for="(msg, index) in betConfirmationErrors" :key="index">
        {{ $t(`Exceptions.${msg}`) }}
      </p>
    </modal>

    <portal to="destination">
      <modal :closeable="true" v-if="showDisabledLinesModal" @close="closeModal" :closeIconNew="true">
        <div slot="body">
          <div style="font-size: 15px; font-weight: bold" class="text-center">{{ $t('BetSlip.LinesDisabed') }}</div>
          <div
            class="text-center"
            v-for="selection in betConfirmationDisabledLines"
            :key="selection.selection_identifier"
          >
            {{ clear(selection.selection_description) }}
          </div>
        </div>
      </modal>
    </portal>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import BetSlipTab from './bet-slip/BetSlipTab';
import OpenBetsTab from './bet-slip/OpenBetsTab';
import { ExternalWagerLoginTypes, LoginTypes } from '@/utils/enums';
import SimpleKeyboard from '@/views/sports/components/bet-slip/SimpleKeyboard';
import BetSlipBetConfirmationModal from '@/views/sports/components/bet-slip/BetSlipBetConfirmationModal';
import BetSlipBetPlaceModalLineChanged from '@/views/sports/components/bet-slip/BetSlipBetPlaceModalLineChanged';
import BetSlipBetPlaceModal from '@/views/sports/components/bet-slip/BetSlipBetPlaceModal';
import { createBet, restoreNewSelections, persistBetSlip, restoreBetSlip } from './bet-slip/bet-slip-utils';
import BetSlipTabOptions from './bet-slip/BetSlipTabOptions';

export default {
  components: {
    BetSlipTab,
    OpenBetsTab,
    SimpleKeyboard,
    BetSlipBetPlaceModal,
    BetSlipBetPlaceModalLineChanged,
    BetSlipBetConfirmationModal,
    BetSlipTabOptions,
  },
  data() {
    return {
      LoginTypes,
      ExternalWagerLoginTypes,
      hasConfirmationErrors: false,
    };
  },
  watch: {
    betConfirmationErrors(value) {
      this.hasConfirmationErrors = value.length > 0;
    },
    selectedLocale: function () {
      this.tryGetTabs();
      this.tryGetOptions();
      this.tryGetOpenBets();
    },
  },
  computed: {
    ...mapFields('betSlip', ['sideMode']),
    ...mapFields('settings', ['showScanBarcodeModal']),
    ...mapState({
      vk_input_value: (state) => state.helper.vk_input_value,
    }),
    ...mapState({
      betSlipBetCount: (state) => state.betSlip.betSlipBetCount,
      newBetSlipSelection: (state) => state.betSlip.newBetSlipSelection,
      openBets: (state) => state.openBetsStore.openBets,
      isLogged: (state) => state.player.isLogged,
      selectedLocale: (state) => state.settings.selectedLocale,
      openBetsStatus: (state) => state.openBetsStore.openBetsStatus,
      loginType: (state) => state.player.loginType,
      ticketOpenBetsStatus: (state) => state.depositTicketStore.ticketOpenBetsStatus,
      ticketOpenBets: (state) => state.depositTicketStore.ticketOpenBets,
      balanceResponse: (state) => state.depositTicketStore.balanceResponse,
      betConfirmationErrors: (state) => state.betSlip.betConfirmationErrors,
      freeWagersViewing: (state) => state.freeWagerStore.freeWagersViewing,
      selectedFreeWager: (state) => state.freeWagerStore.selectedFreeWager,
      clientType: (state) => state.settings.clientType,
      isDefaultDepositFlow: (state) => state.depositTicketStore.isDefaultDepositFlow,
      macAddress: (state) => state.settings.macAddress,
      terminalInfo: (state) => state.settings.terminalInfo,
      currentState: (state) => state.betSlip.currentState,
      betPlaceResponse: (state) => state.betSlip.betPlaceResponse,
      selectedType: (state) => state.betSlip.selectedType,
      selectedTypeName: (state) => state.betSlip.selectedTypeName,
      betTabs: (state) => state.betSlip.betTabs,
      newBetSlipTabs: (state) => state.betSlip.newBetSlipTabs,
      showDisabledLinesModal: (state) => state.betSlip.showDisabledLinesModal,
      confirmationData: (state) => state.betSlip.confirmationData,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    ...mapGetters({
      openBetsSummary: 'openBetsStore/openBetsSummary',
      currencySymbol: 'player/currencySymbol',
    }),
    ...mapFields('player', ['openLogoutModal']),
    ...mapState({
      betConfirmationDisabledLines: (state) => state.betSlip.betConfirmationDisabledLines,
      loginType: (state) => state.player.loginType,
    }),
    isClerk() {
      return this.loginType === LoginTypes.Clerk;
    },
    isPlayer() {
      return this.loginType === LoginTypes.Player;
    },
    isLineChanged() {
      let isLineChanged = false;
      this.confirmationData.map((row) => {
        if (!row.IsSuccess && row.ErrorMessageKey === 'GAMELINECHANGE') {
          isLineChanged = true;
        }
      });
      return isLineChanged;
    },
  },
  methods: {
    ...mapActions({
      startCheckLineAvailityInterval: 'betSlip/startCheckLineAvailityInterval',
      clearCheckLineAvailityInterval: 'betSlip/clearCheckLineAvailityInterval',
      tryGetOpenBets: 'openBetsStore/tryGetOpenBets',
      tryGetTabs: 'betSlip/getBetTabs',
      tryGetOptions: 'betSlip/getNewBetOptions',
      getNewBetOptions: 'betSlip/getNewBetOptions',
      createOrUpdateBet: 'betSlip/createOrUpdateBet',
      closeDisableLinesModal: 'betSlip/closeDisableLinesModal',
      renderBetSlip: 'betSlip/renderBetSlip',
    }),
    ...mapMutations('clerkDepositStore', ['setPrinterStatus']),
    ...mapMutations('player', ['setLoginType']),
    ...mapMutations('depositTicketStore', ['resetState']),
    ...mapMutations('betSlip', ['openBetSlip', 'closeBetSlip']),
    ...mapMutations({
      setCurrentState: 'betSlip/setCurrentState',
      resetBetSlip: 'betSlip/resetBetSlip',
      setSelectedBetType: 'betSlip/setSelectedBetType',
      resetRiskAndWinAmounts: 'betSlip/resetRiskAndWinAmounts',
      setShowLoginNeedModal: 'betSlip/setShowLoginNeedModal',
    }),
    getOpenBetsCount() {
      if (this.loginType === LoginTypes.Player) {
        return this.openBets.length;
      }

      if (this.loginType === ExternalWagerLoginTypes.DepositTicket) {
        return this.ticketOpenBets.length;
      }
      return 0;
    },
    getBetSlipBetsCount() {
      if (this.freeWagersViewing) {
        return Math.min(this.betSlipBetCount, this.selectedFreeWager.pick_count);
      }

      return this.betSlipBetCount;
    },
    setSelectedBetTypeAndGetOptions(options) {
      this.setSelectedBetType(options);
      this.createOrUpdateBet(createBet(options.type, '', 0, 0, 0, 0, 0));
      this.getNewBetOptions();
      // this.resetRiskAndWinAmounts();
    },
    closeModal() {
      this.closeDisableLinesModal();
      //window.location.reload();
    },
    clear(str) {
      return !!str ? str.replace(/\[.*\]/g, '') : '';
    },
  },
  created() {
    this.startCheckLineAvailityInterval();
    this.renderBetSlip();
  },
  destroyed() {
    this.clearCheckLineAvailityInterval();
  },
};
</script>

<style lang="scss">
.bet-slip-content-wrapper {
  @media (min-width: 1440px) {
    height: 100% !important;
  }
}

.close-bet-slip {
  display: none;
  border-left: 1px solid #efefef !important;
  @media (max-width: 992px) {
    display: block;
    border-top-left-radius: 0 !important;
  }
  i {
    color: #fff;
    font-weight: bold;
  }

  &:hover {
    i {
      color: var(--color3);
    }
  }
}
</style>
